import clsx from 'clsx';
import React, { ReactNode } from 'react';

import { cn } from '@/src/util/ui';

type ModalProps = {
  id?: string;
  className?: string;
  position?: string;
  children?: ReactNode;
};

const Modal = ({ id = '', className = '', position = 'bg-overlay', children }: ModalProps) => {
  return (
    <div
      className={cn('modal fade show in', position, '!tw-z-[9999]', className)}
      id={id}
      data-backdrop="static"
      data-keyboard="false"
    >
      {children}
    </div>
  );
};

export default Modal;
